import { props } from "bluebird";
import React from "react";
import CloseIcon from '@material-ui/icons/Close';

import Styles from "./Popover.module.css";

const Popover = (props) => {
	return (
		// backdrop
		<div className={Styles["Popover-backdrop"]} onClick={props.onClose}>
			{/* modal */}
			<div className={Styles["Popover"]}>
				<CloseIcon
					className={Styles["CloseModal"]}
					style={{ cursor: "pointer" }}
					onClick={props.onClose}
				/>
				{props.children}
			</div>
		</div>
	);
};

export default Popover;
